<!-- Infinite scroll is delegated to the outer `.jc-v3-entity-details-body`
     container — the ACTUAL scroll viewport in the V3 Job/Candidate detail
     slider (`job-center-v3.scss:3116`: `overflow-y: auto; flex: 1 1 0;
     min-height: 0`). NOTE: plain `.entity-details-body` is NOT a scroll
     container — its height/overflow rules are commented out in
     `_common.scss:2262`, so targeting it never fired `(scrolled)`.
     The previous `.sub-entities-scroll-container` also failed: it tried to
     be its own viewport but, nested inside the V3 body, its height/overflow
     are neutralized (`job-center-v3.scss:3138`) so it never scrolled either.
     Either way only the first 20 events loaded and the "reached the bottom"
     footer never appeared. This matches the working sibling tabs in the same
     body: `jobs-viewed-by`, `resume-request-sent`, `jobs-applied`. -->
<div infiniteScroll [infiniteScrollDistance]="5" [infiniteScrollThrottle]="1500"
  [infiniteScrollContainer]="'.jc-v3-entity-details-body'" [fromRoot]="true" (scrolled)="onScrollDown()">

  <app-common-skeleton *ngIf="loadAPIcall && eventlist.length == 0;" [countforView]="5" [NameOftheScreen]="'billingHistory'"></app-common-skeleton>

  <ng-container *ngIf=" eventlist.length > 0;">
    <div class="jobs-event-log-container hpanel">
      <table class="panel-body">
        <thead>
          <tr>
            <th>Event <span (click)="sortBy('event')" class="clickable">⬆⬇</span></th>
            <th>Networks <span class="clickable">⬆⬇</span></th>
            <th>By <span (click)="sortBy('by')" class="clickable">⬆⬇</span></th>
            <th>Date <span (click)="sortBy('date')" class="clickable">⬆⬇</span></th>
            <th>Time <span (click)="sortBy('time')" class="clickable">⬆⬇</span></th>
          </tr>
        </thead>


        <tbody>
          <tr *ngFor="let event of eventlist">
            <td>
              <div class="event-type-ellipsis"
                   [title]="(event.activityType === 'JOB_STATUS_UPDATED' || event.activityType === 'CANDIDATE_STATUS_UPDATED')
                            ? this.Event + ' ' + event.activityOn
                            : transformActivityType(event.activityType)">

                <ng-container *ngIf="event.activityType === 'JOB_STATUS_UPDATED' || event.activityType === 'CANDIDATE_STATUS_UPDATED'; else defaultEvent">
                  {{ this.Event|titlecase }} {{ event.activityOn |titlecase}}
                </ng-container>

                <ng-template #defaultEvent>
                  {{ transformActivityType(event.activityType) }}
                </ng-template>
              </div>
            </td>
            <td>
              <div class="network-container ">
                <span class="event-type-ellipsis">{{ event.networks[0] }}</span>
                <span
                  *ngIf="event.networks.length > 1"
                  class="network-count-box"
                  [title]="getAllNetworks(event.networks)"
                >
                  +{{ event.networks.length - 1 }}
                </span>
              </div>
            </td>

            <td  title=" {{ event.activityUserData.firstName }} {{ event.activityUserData.lastName }}" class="event-type-ellipsis">{{ event.activityUserData.firstName }} {{ event.activityUserData.lastName }}</td>
            <td class="event-type-ellipsis">{{ event.createdOn | timezoneDate:'MM/dd/yyyy' }}</td>
            <td class="event-type-ellipsis">{{ event.createdOn | timezoneDate:'h:mm a' }}</td>
          </tr>
        </tbody>
      </table>
      <app-common-skeleton *ngIf="loadAPIcall && eventlist.length > 0;" [countforView]="5" [NameOftheScreen]="'billingHistory'"></app-common-skeleton>
    </div>




  </ng-container>

  <!-- Empty state — same `.jc-v3-empty-state` block the sibling V3 sub-tabs use
       (`jobs-viewed-by`, `jobliked-list`, `resume-request-sent`, …): 200×180
       illustration + h3 + p, centred at the top of the listing. Replaces the old
       `.h-m` div, whose `margin-top:200px` pushed the message below the fold so
       it only showed after scrolling. Copy switches on which detail page hosts
       this tab — the component is shared by Job and Candidate Event Logs. -->
  <div *ngIf="!loadAPIcall && eventlist.length == 0;" class="jc-v3-empty-state">
    <svg width="200" height="180" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="100" cy="90" r="80" fill="#F5F3FF"/>
      <rect x="56" y="42" width="88" height="96" rx="10" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
      <line x1="76" y1="64" x2="76" y2="118" stroke="#C4B5FD" stroke-width="2" stroke-linecap="round"/>
      <circle cx="76" cy="66" r="5" fill="#7C3AED"/>
      <circle cx="76" cy="90" r="5" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
      <circle cx="76" cy="114" r="5" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
      <rect x="88" y="62" width="42" height="5" rx="2.5" fill="#DDD6FE"/>
      <rect x="88" y="71" width="28" height="4" rx="2" fill="#EDE9FE"/>
      <rect x="88" y="86" width="42" height="5" rx="2.5" fill="#DDD6FE"/>
      <rect x="88" y="95" width="24" height="4" rx="2" fill="#EDE9FE"/>
      <rect x="88" y="110" width="36" height="5" rx="2.5" fill="#DDD6FE"/>
      <rect x="88" y="119" width="30" height="4" rx="2" fill="#EDE9FE"/>
      <circle cx="148" cy="128" r="16" fill="#7C3AED" opacity="0.10"/>
      <circle cx="148" cy="128" r="11" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
      <path d="M148 122 v6 l4 3" fill="none" stroke="#7C3AED" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="50" cy="52" r="3" fill="#A78BFA"/>
      <circle cx="155" cy="56" r="2" fill="#C4B5FD"/>
    </svg>
    <h3>No Events Yet</h3>
    <p>{{ candidateDetails ? 'Activity on this candidate will appear here.' : 'Activity on this job will appear here.' }}</p>
  </div>
  <div *ngIf="stopScroll&&eventlist.length > 0" class="jc-v3-list-done">
    <ng-icon name="tablerCircleCheck"></ng-icon>
    <p>You've reached the bottom of the page</p>
  </div>

</div>
